"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactColor = require("react-color");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _hooks = require("../hooks");
var _corezoid_light = _interopRequireDefault(require("../themes/corezoid_light"));
var _Button = _interopRequireDefault(require("../Button/Button.js"));
var _Card = _interopRequireDefault(require("../Card/Card.js"));
var _ColorPicker = _interopRequireDefault(require("./ColorPicker.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Utility function to convert #RRGGBBAA to RGBA
const hexToRgba = (hex = '') => {
  if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const a = hex.length === 9 ? parseInt(hex.slice(7, 9), 16) / 255 : 1;
  return {
    r,
    g,
    b,
    a
  };
};

// Utility function to convert RGBA to #RRGGBBAA
const rgbaToHex = ({
  r,
  g,
  b,
  a
}) => {
  const alpha = Math.round(a * 255);
  // eslint-disable-next-line no-bitwise
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}${alpha.toString(16).padStart(2, '0')}`;
};
const StyledColorPicker = (0, _reactJss.default)(_ColorPicker.default)(({
  classes,
  id,
  className,
  visibility,
  value,
  disableAlpha,
  onChange,
  onSave,
  saveBtnLabel,
  onClose,
  dataTestId
}) => {
  const [color, setColor] = (0, _react.useState)({
    hex: value,
    rgb: !disableAlpha ? hexToRgba(value) : null
  });
  const wrapperRef = (0, _react.useRef)(null);
  (0, _hooks.useOutside)({
    ref: wrapperRef,
    callback: onClose,
    triggers: ['click']
  });
  const handleChange = color => {
    const alphaHexColor = disableAlpha ? color : _objectSpread(_objectSpread({}, color), {}, {
      hex: rgbaToHex(color.rgb)
    });
    setColor(alphaHexColor);
    onChange(alphaHexColor);
  };
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    borderRadius: "none",
    borderWidth: "none",
    withBorder: false,
    id: id,
    className: (0, _clsx.default)(className, classes.colorPicker, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }),
    forwardRef: wrapperRef,
    dataTestId: dataTestId
  }, /*#__PURE__*/_react.default.createElement(_reactColor.ChromePicker, {
    styles: {
      default: {
        body: {
          padding: _corezoid_light.default.spaceSize.small
        }
      }
    },
    color: color,
    onChange: handleChange,
    disableAlpha: disableAlpha
  }), onSave && /*#__PURE__*/_react.default.createElement(_Button.default, {
    dataTestId: dataTestId ? `${dataTestId}-save-button` : undefined,
    type: "quaternary",
    className: classes.closeBtn,
    onClick: () => {
      onSave(color);
      onClose();
    },
    label: saveBtnLabel
  }));
});
StyledColorPicker.defaultProps = {
  visibility: 'visible',
  disableAlpha: false,
  onChange: () => {},
  onClose: () => {},
  onSave: () => {},
  saveBtnLabel: 'Save'
};
const ColorPicker = props => /*#__PURE__*/_react.default.createElement(StyledColorPicker, props);
var _default = exports.default = ColorPicker;